<template lang="pug">
  div.body.body-table
    div.table-choose-panel
      div.toolbar-table
        div.e-select-list.select.list
        div.toolbar.toolbar--modal
          div.line
            div.actions-panel
               e-button-add(@click="addNewRowToTable")

      div
        e-table-editable(
        ref="detail"
        :attributes="detailAttr"
        :dataUrl="dataUrl"
        :postUrl="postUrl"
        :patchUrl="patchUrl"
        :deleteUrl="deleteUrl"
        :tableInOnlineMode="true"
        @sortByField="onSortByField"
        @paginate="onPaginate"
        :tableHeight="'400'"
        :tableHeightRight="'400'"
        :fewRowsCount="2"
        :afterFetchData="afterFetchData"
        )
</template>

<script>
  import {core}      from '@/api/api-endpoints'
  import {transport} from '@/api/api-endpoints'
  import {CALENDAR}  from '@/config/config'

  export default {
    name: 'transport-maintenance-table',
    props: {
      inputModel: {
        type: Object,
        default: () => ({
          id: null
        })
      }
    },
    data () {
      return {
        search: '',
        searchModel: '',
        sort: null
      }
    },
    created() {
      this.loadCollections()
    },
    computed: {
      collections() {
        return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      },
      enableSort () {
        return true
      },
      detailAttr () {
        return {
          tko_transport_maintenance_type_id: {
            label: 'Тип обслуживания',
            validationRulePattern: '(\\.*)',
            required: true,
            select: {
              options: this.maintenanceTypes
            },
            transform: (model) => {
              return this.getOptionName(this.maintenanceTypes, model.tko_transport_maintenance_type_id)
            },
            sort: true
          },
          work_title: {
            label: 'Наименование работ',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            sort: true
          },
          start_date: {
            label: 'Дата начала',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            calendar: {
              valueFormat: CALENDAR.format,
              format: CALENDAR.format
            },
            sort: true
          },
          finish_date: {
            label: 'Дата окончания',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            calendar: {
              valueFormat: CALENDAR.format,
              format: CALENDAR.format
            },
            sort: true
          },
          mileage: {
            label: 'Пробег',
            placeholder: ' ',
            validationRulePattern: '^(\\d*)$',
            sort: true
          },
          tko_transport_condition_id: {
            label: 'Состояние ТС',
            validationRulePattern: '(\\.*)',
            select: {
              options: this.conditions
            },
            transform: (model) => {
              return this.getOptionName(this.conditions, model.tko_transport_condition_id)
            },
            sort: true
          },
          work_scope: {
            label: 'Состав работ',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            sort: true
          },
          comment: {
            label: 'Комментарий',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            sort: true
          }
        }
      },
      dataUrl () {
        let routeQuery = {
          query: {
            tko_transport_id: this.inputModel.id
          }
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }
        if (this.sort) {
          routeQuery.query.sort = this.sort
        }

        return transport.maintenanceOrders(routeQuery)
      },
      maintenanceTypes () {
        return this.collections.tko_transport_maintenance_type || []
      },
      conditions () {
        return this.collections.tko_transport_condition || []
      }
    },
    methods: {
      async loadCollections() {
        return await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getCollectionEndpoint()
        })
      },
      getCollectionEndpoint() {
        return core.collection('tko_transport_maintenance_type,tko_transport_condition')
      },
      getOptionName(collection, id) {
        if (!collection || collection.length < 1 || !id) {
          return null
        }
        return collection.find(v => v.id === id).name
      },
      onPaginate (paginationQuery) {
        this.paginationQuery = paginationQuery
      },
      onSortByField ({sort}) {
        this.sort = sort
      },
      afterFetchData (ctx, data) {
        return data
      },
      postUrl () {
        return transport.maintenance()
      },
      patchUrl (context, model) {
        return transport.maintenance(model.id)
      },
      deleteUrl (context, model) {
        return transport.maintenance(model.id)
      },
      addNewRowToTable () {
        const Model = tko_transport_id => {
          return {
            tko_transport_id,
            tko_transport_condition_id: null,
            tko_transport_maintenance_type_id: null,
            work_title: null,
            work_scope: null,
            comment: null,
            mileage: null,
            start_date: null,
            finish_date: null,
          }
        }
        this.$refs.detail.createRow(new Model(this.inputModel.id))
      }
    }
  }
</script>
